import { ArrowDownIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { floating } from '@/components/assistant-ui/elements/surfaces'
import { cn } from '@/lib/utils'

interface JumpToLatestProps {
  /** Content grew while the reader was scrolled up — draw attention. */
  hasNew: boolean
  onClick: () => void
  className?: string
}

/**
 * "Jump to latest" pill shown while the reader is scrolled away from the
 * bottom (styled after the assistant-ui scroll-anchor element): a round
 * arrow button that bounces while new content keeps arriving below.
 */
export function JumpToLatest({ hasNew, onClick, className }: JumpToLatestProps) {
  const { t } = useTranslation('chat')
  return (
    <button
      type="button"
      aria-label={hasNew ? t('thread.jumpToLatestNew') : t('thread.jumpToLatest')}
      onClick={onClick}
      data-slot="jump-to-latest"
      data-new={hasNew || undefined}
      className={cn(
        floating,
        'grid size-9 place-items-center rounded-full shadow-md transition-transform duration-200 hover:-translate-y-px',
        // animate-in and animate-bounce both set `animation` — pick one.
        hasNew
          ? 'animate-bounce motion-reduce:animate-none'
          : 'fade-in slide-in-from-bottom-2 animate-in',
        className
      )}
    >
      <ArrowDownIcon className="size-4" />
    </button>
  )
}
